

























































































































































































import { axios } from "@/api/axios";
import Client from "@/api/client";
import formatDate from "@/helpers/formatDate";
import Service from "@/models/service";
import { saveServiceTask } from "@/servicetask/api/service-tasks-api";
import { cloneDeep } from "lodash";
import { Vue, Component, Prop, Watch } from "vue-property-decorator";
import OperatorSelect from "../../../components/OperatorSelect.vue";
export interface ServiceTaskFormData {
  id?: number;
  status: string;
  pending: boolean;
  startDate: string;
  endDate: string;
  staff: string;
  memo: string;
  memoEmphasized: boolean;
  otherTasks: {
    id: number;
    shortName: string;
    date: string; // yyyy-MM-dd
  }[];
  constructionTasks: {
    id: number;
    shortName: string;
    status: "done" | "pending";
  }[];
  canEdit?: boolean;
}

@Component({
  components: {
    OperatorSelect
  }
})
export default class ServiceTaskForm extends Vue {
  @Prop({ required: true }) projectId!: number;
  @Prop({ type: Object }) defaultValues?: ServiceTaskFormData;
  @Prop({ required: true }) taskTypeId!: number;
  @Prop({ required: true }) serviceId!: number;

  initTask = cloneDeep(this.defaultValues) as ServiceTaskFormData;
  @Watch("defaultValues", { immediate: true })
  updateValues(defaultValues: ServiceTaskFormData) {
    if (!defaultValues) {
      return;
    }
    this.data = defaultValues;
  }

  @Watch("serviceId", { immediate: true })
  async onChangeServiceId(serviceId: number) {
    if (!serviceId) {
      return;
    }
    await this.getService(serviceId);
  }

  get onMobile() {
    return this.$store.getters.onMobile;
  }

  get client() {
    return new Client(axios);
  }

  get serviceInfo() {
    return this.data.service;
  }

  data: ServiceTaskFormData & {
    notify?: boolean;
    service?: Service;
  } = {
    status: "",
    pending: false,
    startDate: formatDate(new Date()),
    endDate: formatDate(new Date()),
    staff: "",
    memo: "",
    memoEmphasized: false,
    otherTasks: [],
    constructionTasks: [],
    service: new Service()
  };

  pendingOptions = [
    {
      text: "着工",
      value: false
    },
    {
      text: "保留",
      value: true
    }
  ];

  private checkConditionDate() {
    if (!this.data.startDate && !this.data.endDate) {
      throw "start dateは必ず指定してください。, end dateは必ず指定してください。";
    } else if (!this.data.startDate && this.data.endDate) {
      throw "start dateは必ず指定してください。";
    } else if (this.data.startDate && !this.data.endDate) {
      throw "end dateは必ず指定してください。";
    }
  }

  public async submit() {
    try {
      this.checkConditionDate();

      const changed =
        this.data.startDate !== this.initTask.startDate ||
        this.data.endDate !== this.initTask.endDate;

      let confirmed = false;
      if (
        this.serviceInfo &&
        this.serviceInfo.scheduleNotification &&
        changed
      ) {
        if (this.onMobile) {
          confirmed = await this.$bvModal.msgBoxConfirm(
            "この工程変更をチャットへ通知します。よろしいですか？",
            {
              title: "確認",
              okTitle: "はい",
              cancelTitle: "いいえ",
              modalClass: "mt-5"
            }
          );
        } else {
          confirmed = confirm(
            "この工程変更をチャットへ通知します。よろしいですか？"
          );
        }
      }

      if (
        this.serviceInfo &&
        this.serviceInfo.scheduleNotification &&
        changed &&
        confirmed
      ) {
        this.data = {
          ...this.data,
          notify: true
        };
      }

      await saveServiceTask(this.data);
    } catch (e) {
      alert(e);
      throw e;
    }
    this.$emit("submit");
  }

  async getService(currentServiceId: number) {
    const userServices = await this.client.get("get_user_services.php");
    if (userServices) {
      this.data.service = userServices.find(
        (
          s: Service & {
            createdDate?: string;
            currentMonthAppUsers?: number;
            lastMonthAppUsers?: number;
            serviceChart?: boolean;
            users?: number;
          }
        ) => s.id === currentServiceId
      );
    }
  }

  get user() {
    return this.$store.getters.user;
  }

  get editable(): boolean {
    return this.user.can("service/service-tasks/write");
  }
}
